import React, { useEffect, useState } from "react";
import FinancedOffersListComponent from "../components/FinancedOffersListComponent";
import { loadOffers, generateContract } from "../actionCreators";
import { compose, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getFinancedOffers } from "../selectors";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const ContractGenerationContainer = ({ documentId, siteId, actions, financedOffers, isLoaded, loading }) => {
  const [localFinancedOffers, setLocalFinancedOffers] = useState([]);
  const [generateSeparateContracts, setGenerateSeparateContracts] = useState(false);
  const folderStateCode = useSelector(state => state.currentFolder.header.stateCode);

  useEffect(() => {
    actions.loadOffers(documentId, siteId);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isLoaded) {
      let res = JSON.parse(JSON.stringify(financedOffers));
      res = res.map(offer => {
        // eslint-disable-next-line
        offer.assets.map(asset => {
          asset.selected = false;
          // eslint-disable-next-line
          asset.assetsAdditionalInformation.map(assetAdditionalInformation => {
            assetAdditionalInformation.selected = false;
          });
        });
        return offer;
      });
      setLocalFinancedOffers(res);
    } else if (!loading) {
      actions.loadOffers(documentId, siteId);
    }
  }, [isLoaded, loading]); // eslint-disable-line react-hooks/exhaustive-deps

  const openFinancedOffer = (offerId, offerSiteId) => e => {
    e.stopPropagation();
    window.open(`/offers/${offerId}/${offerSiteId}`, "_blank");
  };

  const openOfferAsset = (offerId, offerSiteId, documentDetailId) => () => {
    window.open(`/offers/${offerId}/${offerSiteId}/assets/${documentDetailId}`, "_blank");
  };

  const generateSeparatedContractsChanged = () => _e => {
    setGenerateSeparateContracts(!generateSeparateContracts);
  };

  const selectAssetsForContractGeneration = (offerId, offerSiteId, documentDetailId) => event => {
    const res = localFinancedOffers.map(offer => {
      if (offer.offerId === offerId && offer.offerSiteId === offerSiteId)
        // eslint-disable-next-line
        offer.assets.map(asset => {
          if (asset.id === documentDetailId) asset.selected = event.target.checked;
        });
      return offer;
    });
    setLocalFinancedOffers(res);
  };

  const selectAssetsForContractGenerationV2 = (offerId, offerSiteId, documentDetailId, assetInformationId) => event => {
    const res = localFinancedOffers.map(offer => {
      if (offer.offerId === offerId && offer.offerSiteId === offerSiteId)
        // eslint-disable-next-line
        offer.assets.map(asset => {
          if (asset.id === documentDetailId) {
            if (!assetInformationId) {
              //if the event comes from checking asset check/uncheck all information

              asset.selected = event.target.checked;
              // eslint-disable-next-line
              asset.assetsAdditionalInformation.map(assetAdditionalInformation => {
                assetAdditionalInformation.selected = event.target.checked;
              });
            } else {
              //if the event comes from checking assetAdditionalInformation check just that row
              // eslint-disable-next-line
              asset.assetsAdditionalInformation.map(assetAdditionalInformation => {
                if (assetAdditionalInformation.assetInformationId === assetInformationId)
                  assetAdditionalInformation.selected = event.target.checked;
              });
            }
          }
        });
      return offer;
    });
    setLocalFinancedOffers(res);
  };

  const generateContract = () => {
    let detailIds = [];
    let generateContractForAssetInformation = localFinancedOffers.some(offer =>
      offer.assets.some(asset => asset.assetsAdditionalInformation.some(inf => inf.selected === true))
    );

    if (!generateContractForAssetInformation) {
      // eslint-disable-next-line
      localFinancedOffers.map(offer => {
        // eslint-disable-next-line
        offer.assets.map(asset => {
          if (asset.selected === true) {
            detailIds.push({
              documentDetailId: asset.id,
              masterDocumentId: offer.offerId,
              assetAdditionalInformationIds: []
            });
          }
        });
      });
    } else {
      // eslint-disable-next-line
      localFinancedOffers.map(offer => {
        // eslint-disable-next-line
        offer.assets.map(asset => {
          if (asset.assetsAdditionalInformation.some(inf => inf.selected === true)) {
            let detailId = {
              documentDetailId: asset.id,
              masterDocumentId: offer.offerId,
              assetAdditionalInformationIds: []
            };
            // eslint-disable-next-line
            asset.assetsAdditionalInformation.map(assetAdditionalInformation => {
              if (assetAdditionalInformation.selected === true) {
                detailId.assetAdditionalInformationIds.push(assetAdditionalInformation.assetInformationId);
              }
            });

            detailIds.push(detailId);
          }
        });
      });
    }
    actions.generateContract(documentId, siteId, detailIds, generateSeparateContracts);
    resetSelectedOffersForContractGeneration();
  };

  const resetSelectedOffersForContractGeneration = () => {
    const res = localFinancedOffers.map(offer => {
      // eslint-disable-line
      offer.assets.map(asset => {
        // eslint-disable-line
        asset.selected = false;
        asset.canGenerateContract = false;

        // eslint-disable-next-line
        asset.assetsAdditionalInformation.map(assetAdditionalInformation => {
          assetAdditionalInformation.selected = false;
          assetAdditionalInformation.canGenerateContract = false;
        });

        return asset;
      });
      return offer;
    });
    setLocalFinancedOffers(res);
  };

  return (
    <FinancedOffersListComponent
      documentId={documentId}
      siteId={siteId}
      financedOffers={localFinancedOffers}
      openFinancedOffer={openFinancedOffer}
      openOfferAsset={openOfferAsset}
      selectAssetsForContractGeneration={selectAssetsForContractGeneration}
      selectAssetsForContractGenerationV2={selectAssetsForContractGenerationV2}
      generateContract={generateContract}
      generateSeparatedContractsChanged={generateSeparatedContractsChanged}
      generateSeparateContracts={generateSeparateContracts}
      folderStateCode = {folderStateCode}
    />
  );
};

ContractGenerationContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  financedOffers: PropTypes.array.isRequired,
  isLoaded: PropTypes.bool,
  loading: PropTypes.bool
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadOffers, generateContract }, dispatch),
    dispatch
  };
}

function mapStateToProps(state, ownProps) {
  return {
    financedOffers: getFinancedOffers(state, ownProps.documentId, ownProps.siteId),
    isLoaded: state.document.contractGeneration.isLoaded,
    loading: state.document.contractGeneration.loading
  };
}

export default withRouter(compose(connect(mapStateToProps, mapDispatchToProps))(ContractGenerationContainer));
